// extracted by mini-css-extract-plugin
export default {"codeSnippet":"CodeSnippet__codeSnippet___E5xS5","copyWidget":"CodeSnippet__copyWidget___m2DAX","tooltip":"CodeSnippet__tooltip___WC1T0"};